import countdown from "../countdown";


export default (function () {
    var init = function () {
        var spCountDown = document.getElementById("spCountDown");
        if (!spCountDown || !spCountDown.dataset.secondsRemaining) {
            return;
        }
        var secondsRemaining = spCountDown.dataset.secondsRemaining;
        countdown.init(parseInt(secondsRemaining), 'spCountDown');
    };   

    return {
        init: init
    };

})();

